import React, { useEffect } from 'react';
import Layout from './layout/Layout';
import TransUnionDeviceRisk from './services/transunionDeviceRisk';


import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/custom.css';

// Error handling global variables
window.$errorCode = null;
window.$errorMessage = "";

function App() {

    useEffect(() => {
        // TransUnion Device Risk only runs on the allowed prequal2 websites
        const transUnionEnabledUrls = JSON.parse(process.env.REACT_APP_TRANSUNION_DEVICE_RISK_URLS || "[]");
        if (transUnionEnabledUrls.includes(window.location.origin)) {
            TransUnionDeviceRisk.loadDeviceRisk();
        }
    }, []);

    return (
        <Layout />
    );
}

export default App;
